import React from 'react'

const HeroSvg: React.FC = (props) => (
	<svg {...props} width='548' height='477' viewBox='0 0 548 477' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='59' y='321' width='489' height='12.1832' fill='#DFDFDF' />
		<rect x='87.1514' y='333.183' width='432.697' height='0.870229' fill='#CDCDCD' />
		<rect x='87.1514' y='334.053' width='432.697' height='4.35115' fill='#DFDFDF' />
		<rect x='80.7023' y='302.473' width='22.626' height='16.5344' fill='#DFDFDF' />
		<path
			d='M114.007 277.175C114.007 281.887 106.831 283.075 104.508 286.512C101.331 291.214 108.916 298.464 103.378 298.464C89.5746 299.299 97.4758 303.614 94.1489 302.474C92.6456 301.958 87.325 303.067 86.8032 302.474C85.6671 301.182 90.0389 297.859 84.4891 294.724C76.3899 290.15 83.4397 284.261 83.4397 279.548C83.4397 274.836 69.7437 260.788 83.0038 264.689C96.2639 268.591 85.8128 255.837 91.3505 255.837C96.8883 255.837 105.8 246.742 105.8 259.443C101.818 271.955 114.007 272.462 114.007 277.175Z'
			fill='#0CFDD7'
		/>
		<path
			d='M102.086 252.698C102.086 252.698 96.3285 284.123 93.3686 286.517C90.4088 288.912 91.2967 302.124 91.2967 302.124'
			stroke='#191919'
			strokeWidth='0.5'
		/>
		<path d='M77.5942 266.796C86.8089 268.311 91.0324 270.51 96.8675 276.845' stroke='#191919' strokeWidth='0.5' />
		<path d='M95.9599 280.66C102.812 278.16 106.723 277.661 113.837 278.412' stroke='#191919' strokeWidth='0.5' />
		<path d='M80.9035 288.042C85.7491 286.886 88.1752 287.037 92.014 288.653' stroke='#191919' strokeWidth='0.5' />
		<path d='M91.758 289.729C98.7707 291.15 101.673 292.918 104.819 297.984' stroke='#191919' strokeWidth='0.5' />
		<circle cx='80.2672' cy='310.74' r='8.26718' fill='#DFDFDF' />
		<rect width='22.626' height='16.5344' transform='matrix(-1 0 0 1 103.328 302.473)' fill='#DFDFDF' />
		<circle r='8.26718' transform='matrix(-1 0 0 1 103.763 310.74)' fill='#DFDFDF' />
		<rect x='79' y='319' width='26' height='2' fill='#989696' />
		<circle cx='531.672' cy='299.634' r='7.39695' fill='#DFDFDF' />
		<circle cx='531.672' cy='299.634' r='4.78626' fill='#1F1F1F' />
		<path
			d='M506 289.626H532.107V317.907C532.107 317.907 529.708 319.793 523.84 320.735C520.768 321.228 511.846 320.735 510.351 320.735C506 320.735 506 317.907 506 317.907V289.626Z'
			fill='#DFDFDF'
		/>
		<path
			d='M506 289.626H532.107V317.907C532.107 317.907 529.708 319.793 523.84 320.735C520.768 321.228 511.846 320.735 510.351 320.735C506 320.735 506 317.907 506 317.907V289.626Z'
			fill='#DFDFDF'
		/>
		<path
			d='M506 289.626H532.107V317.907C532.107 317.907 529.708 319.793 523.84 320.735C520.768 321.228 511.846 320.735 510.351 320.735C506 320.735 506 317.907 506 317.907V289.626Z'
			fill='#DFDFDF'
		/>
		<path
			d='M506 289.626H532.107V317.907C532.107 317.907 529.708 319.793 523.84 320.735C520.768 321.228 511.846 320.735 510.351 320.735C506 320.735 506 317.907 506 317.907V289.626Z'
			fill='#DFDFDF'
		/>
		<path
			d='M532.107 289.626H506V317.907C506 317.907 508.398 319.793 514.267 320.735C517.339 321.228 526.261 320.735 527.756 320.735C532.107 320.735 532.107 317.907 532.107 317.907V289.626Z'
			fill='#DFDFDF'
		/>
		<path
			d='M532.107 289.626H506V317.907C506 317.907 508.398 319.793 514.267 320.735C517.339 321.228 526.261 320.735 527.756 320.735C532.107 320.735 532.107 317.907 532.107 317.907V289.626Z'
			fill='#DFDFDF'
		/>
		<path
			d='M532.107 289.626H506V317.907C506 317.907 508.398 319.793 514.267 320.735C517.339 321.228 526.261 320.735 527.756 320.735C532.107 320.735 532.107 317.907 532.107 317.907V289.626Z'
			fill='#DFDFDF'
		/>
		<path
			d='M532.107 289.626H506V317.907C506 317.907 508.398 319.793 514.267 320.735C517.339 321.228 526.261 320.735 527.756 320.735C532.107 320.735 532.107 317.907 532.107 317.907V289.626Z'
			fill='#DFDFDF'
		/>
		<path
			d='M525.34 275.311C523.549 276.892 523.224 280.857 522.163 281.299C521.173 281.712 519.452 278.568 517.722 280.77C514.137 285.332 513.771 276.696 512.1 274.496C510.43 272.296 506.093 267 510.593 267C515.093 267 528.803 272.255 525.34 275.311Z'
			fill='#DFDFDF'
		/>
		<path
			d='M521.878 283.621C521.878 285.039 519.998 286.799 518.333 286.799C516.668 286.799 518.333 285.65 518.333 284.232C518.333 282.815 516.668 281.666 518.333 281.666C519.998 281.666 521.878 282.204 521.878 283.621Z'
			fill='#DFDFDF'
		/>
		<path d='M528 294V316.354L525 319.354' stroke='#C4C4C4' strokeWidth='2' strokeLinecap='round' />
		<rect x='1.5' y='1.5' width='212.725' height='125.702' fill='#D4D4D4' stroke='#535461' strokeWidth='3' />
		<rect x='97.103' y='40.5' width='27' height='15' fill='#BBB8B8' stroke='#B1B0B0' />
		<rect x='104.603' y='43' width='11' height='5' rx='1' fill='#989696' />
		<line x1='102.103' y1='51.5' x2='118.103' y2='51.5' stroke='#625C5C' strokeLinecap='round' />
		<rect x='101.103' y='95.5' width='28' height='17' fill='white' stroke='#CDCDCD' />
		<rect x='103.603' y='97' width='25' height='5' fill='#C4C4C4' />
		<line x1='111.103' y1='104.5' x2='125.103' y2='104.5' stroke='#CDCDCD' strokeLinecap='round' />
		<line x1='113.103' y1='108.5' x2='126.103' y2='108.5' stroke='#CDCDCD' strokeLinecap='round' />
		<rect x='84.103' y='86.5' width='37' height='22' fill='white' stroke='#CDCDCD' />
		<path d='M84.603 89H119.603V94H84.603V89Z' fill='#C4C4C4' />
		<rect x='91.603' y='96' width='27' height='3' rx='1.5' fill='#C4C4C4' />
		<line x1='88.103' y1='97.5' x2='97.103' y2='97.5' stroke='#0CFDD7' strokeLinecap='round' />
		<line x1='88.103' y1='100.5' x2='107.103' y2='100.5' stroke='#CDCDCD' strokeLinecap='round' />
		<line x1='88.103' y1='106.5' x2='110.103' y2='106.5' stroke='#CDCDCD' strokeLinecap='round' />
		<line x1='88.103' y1='103.5' x2='110.103' y2='103.5' stroke='#CDCDCD' strokeLinecap='round' />
		<rect x='144.477' y='18.2939' width='43.3817' height='66.8779' fill='white' stroke='#CDCDCD' />
		<line x1='150.103' y1='38.5' x2='183.103' y2='38.5' stroke='#CDCDCD' strokeLinecap='round' />
		<line x1='154.103' y1='59.5' x2='162.103' y2='59.5' stroke='#CDCDCD' strokeLinecap='round' />
		<line x1='172.103' y1='58.5' x2='181.103' y2='58.5' stroke='#0CFDD7' strokeLinecap='round' />
		<line x1='151.103' y1='62.5' x2='182.103' y2='62.5' stroke='#CDCDCD' strokeLinecap='round' />
		<line x1='152.103' y1='65.5' x2='181.103' y2='65.5' stroke='#CDCDCD' strokeLinecap='round' />
		<line x1='159.103' y1='73.5' x2='172.103' y2='73.5' stroke='#CDCDCD' strokeLinecap='round' />
		<rect x='152.603' y='25' width='29' height='8' rx='1' fill='#CDCDCD' />
		<rect x='33.103' y='39.5' width='39.0305' height='43.3817' rx='4.5' fill='white' stroke='#CDCDCD' />
		<line x1='38.103' y1='76.5' x2='64.103' y2='76.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='38.103' y1='72.5' x2='55.103' y2='72.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='38.103' y1='58.5' x2='64.103' y2='58.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='38.103' y1='62.5' x2='55.103' y2='62.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='38.103' y1='54.5' x2='64.103' y2='54.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='37.103' y1='66.5' x2='63.103' y2='66.5' stroke='#DFDFDF' strokeLinecap='round' />
		<circle cx='39.603' cy='48' r='3' fill='#DFDFDF' />
		<path d='M45.603 49.5H56.103H66.603M45.603 47H66.603' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='37.103' y1='69.5' x2='63.103' y2='69.5' stroke='#DFDFDF' strokeLinecap='round' />
		<rect x='26.103' y='28.5' width='39.0305' height='43.3817' rx='4.5' fill='white' stroke='#CDCDCD' />
		<line x1='31.103' y1='65.5' x2='57.103' y2='65.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='31.103' y1='61.5' x2='48.103' y2='61.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='31.103' y1='47.5' x2='57.103' y2='47.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='31.103' y1='51.5' x2='48.103' y2='51.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='31.103' y1='43.5' x2='57.103' y2='43.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='30.103' y1='55.5' x2='56.103' y2='55.5' stroke='#DFDFDF' strokeLinecap='round' />
		<circle cx='32.603' cy='37' r='3' fill='#DFDFDF' />
		<path d='M38.603 38.5H49.103H59.603M38.603 36H59.603' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='30.103' y1='58.5' x2='56.103' y2='58.5' stroke='#DFDFDF' strokeLinecap='round' />
		<rect x='33.103' y='39.5' width='39.0305' height='43.3817' rx='4.5' fill='white' stroke='#CDCDCD' />
		<line x1='38.103' y1='76.5' x2='64.103' y2='76.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='38.103' y1='72.5' x2='55.103' y2='72.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='38.103' y1='58.5' x2='64.103' y2='58.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='38.103' y1='62.5' x2='55.103' y2='62.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='38.103' y1='54.5' x2='64.103' y2='54.5' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='37.103' y1='66.5' x2='63.103' y2='66.5' stroke='#DFDFDF' strokeLinecap='round' />
		<circle cx='39.603' cy='48' r='3' fill='#DFDFDF' />
		<path d='M45.603 49.5H56.103H66.603M45.603 47H66.603' stroke='#DFDFDF' strokeLinecap='round' />
		<line x1='37.103' y1='69.5' x2='63.103' y2='69.5' stroke='#DFDFDF' strokeLinecap='round' />
		<rect x='249' y='214' width='108' height='173' rx='7' fill='#0E0E0E' />
		<rect x='300' y='387' width='8' height='13' fill='#989696' />
		<path
			d='M250 400H358V402C358 407.523 353.523 412 348 412H260C254.477 412 250 407.523 250 402V400Z'
			fill='#0E0E0E'
		/>
		<rect x='259' y='412' width='89' height='6' fill='#989696' />
		<rect x='295' y='418' width='18' height='6' fill='#535461' />
		<path d='M280.5 474.5L301.5 459V465.5L281.5 477L280.5 474.5Z' fill='#535461' />
		<path d='M280.5 474.5L301.5 459V465.5L281.5 477L280.5 474.5Z' fill='#535461' />
		<path d='M327 474.5L306 459V465.5L326 477L327 474.5Z' fill='#535461' />
		<path d='M327 474.5L306 459V465.5L326 477L327 474.5Z' fill='#535461' />
		<path d='M300 424H305.5V477H302L300 424Z' fill='#535461' />
		<path d='M308 424H302.5V477H306L308 424Z' fill='#535461' />
		<rect x='406' y='338' width='100' height='139' fill='#D4D4D4' />
		<rect x='418' y='364' width='76' height='29.4118' fill='#353542' />
		<rect x='418' y='434.588' width='76' height='29.4118' fill='#353542' />
		<rect x='418' y='399.294' width='76' height='29.4118' fill='#353542' />
		<path
			d='M440 375H471V375C471 379.418 467.418 383 463 383H448C443.582 383 440 379.418 440 375V375Z'
			fill='#D4D4D4'
		/>
		<path
			d='M440 410H471V410C471 414.418 467.418 418 463 418H448C443.582 418 440 414.418 440 410V410Z'
			fill='#D4D4D4'
		/>
		<path
			d='M440 445H471V445C471 449.418 467.418 453 463 453H448C443.582 453 440 449.418 440 445V445Z'
			fill='#D4D4D4'
		/>
		<rect x='418' y='346' width='76' height='11' fill='#353542' />
		<rect x='442' y='349' width='27' height='5' rx='2.5' fill='#C4C4C4' />
		<rect x='99' y='338' width='12' height='139' fill='#DFDFDF' />
	</svg>
)

export default HeroSvg
